import { BuiltInComponents } from 'craft/constants';
import { useEditor } from 'craft/hooks';

import { useForm } from './useForm';

export const useFormAncestor = (nodeId?: string) => {
  const { query } = useEditor();
  const selectedNode = query.node(nodeId)?.get();

  const formNodeId =
    selectedNode?.data?.name === BuiltInComponents.Form
      ? selectedNode.id
      : query
          .node(nodeId)
          ?.ancestors(true)
          ?.find((n) => query.node(n)?.get()?.data?.name === BuiltInComponents.Form);

  const form = useForm(formNodeId);

  if (!formNodeId) {
    return { isInForm: false, ...form, formNodeId };
  }

  return {
    isInForm: true,
    ...form,
    formNodeId,
  };
};
